import { RootState } from "../../../../store";

export const resourceExplorerQuarterEndForecastVisibilitySelector = (
  state: RootState,
) => {
  return state.resourceExplorer?.quarterEndForecastVisibility;
};
